/** @jsxImportSource @emotion/react */
import CancelIcon from "@mui/icons-material/CancelSharp";
import { IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.secondary.swaBlack,
    fontSize: "30px",
  },
}));

const StarsCloseIconButton = (props) => {
  const classes = useStyles();

  return (
    <IconButton
      className={props.className}
      aria-label="Close"
      onClick={(event) => props.onClick(event)}
      size="large"
      sx={{
        float: "right",
        marginTop: "-16px",
        marginRight: "-20px",
        marginBottom: "-20px",
        padding: "6px",
      }}
    >
      <CancelIcon className={classes.icon} />
    </IconButton>
  );
};

StarsCloseIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default StarsCloseIconButton;
